import React, { memo } from 'react';
import PropTypes from 'prop-types';
import CustomInput from './CustomInput';

const CustomSelect = ({ label, name, options, value, onChange, hasOther, customValue, onCustomChange, error, optionName }) => {
  // Ensure options is an array, default to empty array if invalid
  const validOptions = Array.isArray(options) ? options : [];

 // Extract plain number (e.g., "2", "10")
const getPlainNumber = (str) => {
  const match = String(str).match(/^\d+$/);
  return match ? Number(match[0]) : null;
};

const sortedOptions = [...validOptions].sort((a, b) => {
  if (hasOther && a === 'Other') return 1;
  if (hasOther && b === 'Other') return -1;

  const getLayoutValues = (str) => {
    const match = String(str).match(/^(\d+)X(\d+)$/);
    return match ? [Number(match[1]), Number(match[2])] : null;
  };

  const getPixelValue = (str) => {
    const match = String(str).match(/^(\d+)pt$/);
    return match ? Number(match[1]) : null;
  };

  const aLayout = getLayoutValues(a);
  const bLayout = getLayoutValues(b);
  const aPixel = getPixelValue(a);
  const bPixel = getPixelValue(b);
  const aNumber = getPlainNumber(a);
  const bNumber = getPlainNumber(b);

  // Layout formats (e.g., 4X3, 10X5)
  if (aLayout && bLayout) {
    if (aLayout[0] !== bLayout[0]) return aLayout[0] - bLayout[0];
    return aLayout[1] - bLayout[1];
  }

  // Pixel values (e.g., 8px, 12px)
  if (aPixel !== null && bPixel !== null) {
    return aPixel - bPixel;
  }

  // Plain numbers (e.g., 2, 3, 10)
  if (aNumber !== null && bNumber !== null) {
    return aNumber - bNumber;
  }

  // Default alphabetical
  return String(a).localeCompare(String(b));
});


  return (
    <div className="relative mb-1">
      <label className="text-gray-900 text-md mt-1 font-semibold">{label}</label>
      <select
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        className="custom-select w-full mt-0 p-3 bg-transparent border border-gray-500 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-600 bg-white"
      >
        <option value="">Select {optionName === 'Cm' ? 'Size' : optionName}</option>
        {sortedOptions.map((option) => (
          <option key={option} value={option}>
            {option} {['Lines', 'Cm'].includes(optionName) ? optionName : ""}
          </option>
        ))}
        {hasOther && !sortedOptions.includes('Other') && (
          <option value="Other">Other</option>
        )}
      </select>
      {error && <p className="text-red-400 text-sm mt-1">{error}</p>}
      {hasOther && value === 'Other' && (
        <CustomInput
          id={`custom${name}`}
          label={`Custom ${name}`}
          name={`custom${name}`}
          value={customValue}
          onChange={onCustomChange}
          placeholder={`Enter custom ${name.toLowerCase()}`}
          labelClassName="text-blue-500"
        />
      )}
    </div>
  );
};

CustomSelect.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  hasOther: PropTypes.bool,
  customValue: PropTypes.string,
  onCustomChange: PropTypes.func,
  error: PropTypes.string,
};

CustomSelect.defaultProps = {
  hasOther: false,
  customValue: '',
  onCustomChange: () => { },
  error: null,
};

export default memo(CustomSelect);